/*
 * @Author: wuxi
 * @Date: 2022-02-16 19:10:51
 * @LastEditors: wuxi
 * @LastEditTime: 2022-02-16 19:10:53
 * @FilePath: \csx-b2b-front-supplier\components\categoryManage\index.js
 * @Description:
 */
/***
 * 管理品类
 */

import React, { useEffect, useState } from 'react';
import { getData } from '@util';
import { TreeSelect } from 'antd';
import { API_GET_LOAD_MANAGEMENT_CATEGORY_TREE } from '@api';

const CategoryManage = ({ single, isValueSpliceLabel, ...props }) => {
  const [optionData, setOptionData] = useState([]);

  const getMenu = data => {
    const childrenBox = [];
    data.map(item => {
      const obj = {};
      obj.title = `${item.value}${item.label}`;
      obj.value = isValueSpliceLabel ? `${item.value}-${item.label}` : `${item.value}`;
      obj.key = item.value;
      obj.children = item.children;
      if (item && item.children !== null) {
        if (single) {
          obj.disabled = true;
        }
        obj.children = getMenu(item.children);
      }
      childrenBox.push(obj);
    });
    return childrenBox;
  };

  const getPurchaseOrgCode = () => {
    getData({
      api: API_GET_LOAD_MANAGEMENT_CATEGORY_TREE,
    }).then(res => {
      const data = getMenu(res.data);
      setOptionData(data);
    });
  };

  useEffect(() => {
    getPurchaseOrgCode();
  }, []);

  return (
    <TreeSelect
      placeholder="请选择"
      treeData={optionData}
      treeCheckable={!single}
      allowClear={true}
      maxTagCount={6}
      treeNodeFilterProp="title"
      multiple={!single}
      {...props}
    />
  );
};

export default React.memo(CategoryManage);
